import * as KJUR from 'jsrsasign';

export async function generateSignature(
  meetingNumber,
  role
) {
  const sdkKey = process.env.REACT_APP_ZOOM_MEETING_SDK_KEY;
  const sdkSecret = process.env.REACT_APP_ZOOM_MEETING_SDK_SECRET;

  if (!sdkKey || !sdkSecret) {
    throw new Error('Missing Zoom SDK credentials (REACT_APP_ZOOM_MEETING_SDK_KEY / REACT_APP_ZOOM_MEETING_SDK_SECRET).');
  }

  const normalizedRole = Number(role);
  const normalizedMeetingNumber = String(meetingNumber);

  if (!Number.isInteger(normalizedRole) || (normalizedRole !== 0 && normalizedRole !== 1)) {
    throw new Error(`Invalid meeting role for Zoom signature: ${role}`);
  }

  if (!normalizedMeetingNumber) {
    throw new Error('Missing meeting number for Zoom signature.');
  }

  const iat = Math.round(new Date().getTime() / 1000) - 30;
  const exp = iat + 60 * 60 * 2;

  const oHeader = { alg: 'HS256', typ: 'JWT' };

  const oPayload = {
    mn: normalizedMeetingNumber,
    role: normalizedRole,
    iat: iat,
    exp: exp,
    appKey: sdkKey,
    tokenExp: exp,
    video_webrtc_mode: 1
  };

  const sHeader = JSON.stringify(oHeader);
  const sPayload = JSON.stringify(oPayload);
  const signature = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, sdkSecret);

  // console.log(signature);

  return signature;
};